export const OPEN_RECOMMEND_MODAL = 'MODALS/OPEN_RECOMMEND_MODAL';
export const CLOSE_RECOMMEND_MODAL = 'MODALS/CLOSE_RECOMMEND_MODAL';

export const GET_RECOMMEND_DATA_REQUEST_START_LOADING = 'PORTFOLIO/GET_RECOMMEND_DATA_REQUEST_START_LOADING';
export const GET_RECOMMEND_DATA_REQUEST_END_LOADING = 'PORTFOLIO/GET_RECOMMEND_DATA_REQUEST_END_LOADING';
export const GET_RECOMMEND_REQUEST = 'PORTFOLIO/GET_RECOMMEND_REQUEST';
export const GET_RECOMMEND_DATA_SUCCESS = 'PORTFOLIO/GET_RECOMMEND_DATA_SUCCESS';

export const UPDATE_LAST_RECOMMEND_VIEW_TIME = 'PORTFOLIO/UPDATE_LAST_RECOMMEND_VIEW_TIME';
